import React from 'react';
import styled from 'styled-components';
import _floor from 'lodash/floor';
import _divide from 'lodash/divide';
import _isNumber from 'lodash/isNumber';

const NavCount = styled.div`
  .question-attempted-meter {
    height: 100%;
    border-top: 0;
    border-bottom: 0;

    .meter {
      height: 12px;
      width: 100%;
      border-radius: 10px;
      background: #1a1c4f;
      overflow: hidden;

      .progress {
        z-index: 30;
        border-radius: 10px;
        height: 12px;
        -webkit-transition: width 0.5s ease-in-out;
        -moz-transition: width 0.5s ease-in-out;
        -o-transition: width 0.5s ease-in-out;
        transition: width 0.5s ease-in-out;

        &--left-align {
          float: left;
        }

        &-success {
          background: #2ecc71;
        }

        &--right-align {
          float: right;
        }

        &-danger {
          background: #ff5d50;
        }
      }
    }

    .description {
      font-size: 13px;
      text-align: center;
      padding: 6px 2px;
      color: white;
    }

    @media (max-width: 375px) {
      width: 120px;
    }
  }
`;

export default function NavProblemCount({ total, attempted }) {
  const count = _isNumber(attempted) && attempted > 0 ? attempted : 0;
  const width = _floor(_divide(count * 100, total));
  return (
    <NavCount
      className="ml-md-3 ml-lg-5 pt-1 pt-md-2"
      id="do-test-problem-counter"
    >
      <div className="question-attempted-meter">
        <div className="meter">
          <div
            className="progress progress-success progress--left-align "
            style={{ width: width ? `${width}%` : '0px' }}
          />
        </div>
        <div className="description">
          {count}/{total} Question{total > 1 ? 's' : ''} attempted
        </div>
      </div>
    </NavCount>
  );
}
